import { Button, Typography } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import { useNavigate } from "react-router-dom";

type Props = {
  message: string;
};

export default function UnavailableContent({ message }: Props) {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate("/account/subscription?changePlan=true");
  };

  return <Box sx={styles.container}>
    <Typography variant="subtitle2" sx={styles.message}>{message}</Typography>
    <Button variant="outlined" onClick={handleUpgradeClick}>Upgrade to PREMIUM</Button>
  </Box>;
}

const styles: { [key in string]: SxProps } = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
  },
  message: {
    textAlign: "center"
  }
}